import React, { PropTypes } from 'react'

const BillingDefault  = ({ openSearch }) => {
  return (
    <div className="jumbotron">
      <h1>Billing Assessment</h1>
      <p>Student billing module.</p>
      <hr />
      <button onClick={openSearch} type="button" className="btn btn-warning">Search Student</button>
    </div>
  )
}

BillingDefault.propTypes = {
  openSearch: PropTypes.func,
}

export default BillingDefault



// WEBPACK FOOTER //
// ./src/containers/Billing/default.js